import { render } from "./ViewUsers.vue?vue&type=template&id=8182e514&scoped=true"
import script from "./ViewUsers.vue?vue&type=script&lang=js"
export * from "./ViewUsers.vue?vue&type=script&lang=js"

import "./ViewUsers.vue?vue&type=style&index=0&id=8182e514&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8182e514"]])

export default __exports__